import { useContext } from 'react';
import {
  DetailContext,
  abortableFetch,
  useEventCallback,
} from '@eas/common-web';
import { EsFileState, EvidenceApiUrl } from '@enums';

export function useDeleteRegulationDialog() {
  const { source } = useContext(DetailContext);

  const callApi = useEventCallback(
    (
      esFileId: string,
      regulationIds: string[],
      updateClosed = source.data?.state === EsFileState.CLOSED
    ) => {
      return abortableFetch(
        `${EvidenceApiUrl.ES_FILES}/${esFileId}/regulation${
          updateClosed ? '/update-closed' : ''
        }`,
        {
          method: 'DELETE',
          headers: new Headers({
            'Content-Type': 'application/json',
          }),
          body: JSON.stringify(regulationIds),
        }
      );
    }
  );

  return {
    callApi,
  };
}
